import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const propTypes = {
  children: PropTypes.node.isRequired,
};

function Item({ children }) {
  return <StyledItem>{children}</StyledItem>;
}
const StyledItem = styled.li`
  display: block;
  position: relative;

  & + li {
    padding-left: 30px;
  }
  @media (max-width: 1200px) {
    width: 100%;
    & + li {
    padding-left: 0;
  }
}
`;

Item.propTypes = propTypes;

export default Item;
